/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendAdditionalProjectInformationFieldDto } from '../../models/backend-additional-project-information-field-dto';
import { BackendPatchedAdditionalProjectInformationFieldRequestDto } from '../../models/backend-patched-additional-project-information-field-request-dto';

export interface ProjectsAdditionalProjectInformationPartialUpdate$XWwwFormUrlencoded$Params {
  id: number;
  body?: BackendPatchedAdditionalProjectInformationFieldRequestDto;
}

export function projectsAdditionalProjectInformationPartialUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsAdditionalProjectInformationPartialUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendAdditionalProjectInformationFieldDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    projectsAdditionalProjectInformationPartialUpdate$XWwwFormUrlencoded.PATH,
    'patch',
  );
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendAdditionalProjectInformationFieldDto>;
    }),
  );
}

projectsAdditionalProjectInformationPartialUpdate$XWwwFormUrlencoded.PATH =
  '/api/projects/additional_project_information/{id}/';
